import { Indicator } from '../../../Common/Charts/Indicator';
import { useVaccinationChartsDataContext } from './hooks/useVaccinationChartsDataContext';

export const VaccinatedKidsUnderOneYearWithPenta = () => {
    const { chartData } = useVaccinationChartsDataContext();

    return (
        <Indicator
            title={'Crianças de 1 ano vacinadas com vacina DTP/HB/HIB'}
            indicatorValue={chartData?.indicators?.vaccinatedKidsUnderOneYearWithPenta}
        />
    );
};
